import {
  bindable, createTypedBindable, usePropertyTypeForBindable, usePropertyTypeForObservable, coerceFunctions
} from 'aurelia-typed-observable-plugin';

usePropertyTypeForBindable(true);
usePropertyTypeForObservable(true);

bindable.boolean = createTypedBindable('boolean');
coerceFunctions.boolean = val => {
  if (val === undefined) {
    return undefined;
  } else if (val === null) {
    return null;
  } else {
    return (val || val === '') && val !== 'false' ? true : false;
  }
};

bindable.number = createTypedBindable('number');
coerceFunctions.number = val => {
  if (val === undefined || val === '' || val === 'undefined' || val === 'NaN') {
    return undefined;
  } else if (val === null || val === 'null') {
    return null;
  } else {
    return Number(val);
  }
};

bindable.string = createTypedBindable('string');
coerceFunctions.string = val => {
  if (val === undefined) {
    return undefined;
  } else if (val === null) {
    return null;
  } else {
    return `${val}`;
  }
};

export { };
